import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Section = ({ id, className, width, children, backgroundImage }) => {
  const data = useStaticQuery(graphql`
    query {
      defaultImage: file(relativePath: { eq: "backgrounds/1.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `)

  // Define an array of image paths
  const imagePaths = ["defaultImage"]

  // Replace this condition with your logic to determine which image to use
  const selectedImageIndex = backgroundImage ? backgroundImage : 0 // Change this index to select a different image

  // Ensure the selected index is within the range of available images
  const selectedImagePath = imagePaths[selectedImageIndex]

  // If the selected image path is undefined, use a default image
  const imageData = selectedImagePath ? data[selectedImagePath] : null

  const image = getImage(imageData)

  if (!image) {
    console.error("GatsbyImage component image is undefined.")
    return null
  }

  return (
    <section
      className={`relative py-24 ${className ? className : ""}`}
      id={id ? id : ""}
    >
      {/* Background images */}
      {backgroundImage && (
        <div className={"absolute inset-0 w-full h-full z-0 overflow-hidden"}>
          <GatsbyImage
            image={image}
            alt={"Banner Image"}
            className={"w-full h-full object-cover opacity-20"}
          />
        </div>
      )}

      <div className={"relative z-5"}>{children}</div>
    </section>
  )
}

export default Section
